import { render, staticRenderFns } from "./RecommendedListEdit.vue?vue&type=template&id=7bc74ccb&scoped=true&"
import script from "./RecommendedListEdit.vue?vue&type=script&lang=js&"
export * from "./RecommendedListEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedListEdit.vue?vue&type=style&index=0&id=7bc74ccb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc74ccb",
  null
  
)

export default component.exports